import { render, staticRenderFns } from "./ImpressaoPAFs.vue?vue&type=template&id=153cd205"
import script from "./ImpressaoPAFs.vue?vue&type=script&lang=js"
export * from "./ImpressaoPAFs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports